export const GET_WELCOME_APP = 'GET_WELCOME_APP';
export const GET_WELCOME_APP_SUCEESS = 'GET_WELCOME_APP_SUCEESS';
export const CLOSE_POP = 'CLOSE_POP';
export const IS_OPEN_WELCOME_POP = 'IS_OPEN_WELCOME_POP';
export const GET_CUSTOME_SELECT_POP_STATUS = 'GET_CUSTOME_SELECT_POP_STATUS';
export const GET_CUSTOME_SELECT_POP_STATUS_SUCEESS = 'GET_CUSTOME_SELECT_POP_STATUS_SUCEESS';
export const IS_CUSTOMER_CLICK = 'IS_CUSTOMER_CLICK';
export const CHANGE_CHECK_STATUS = 'CHANGE_CHECK_STATUS';
